import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            // Global error handling strategy - skip console errors for 401s
            // as they are handled/refreshed by AuthInterceptor
            if (error.status !== 401) {
                console.error('API Error:', error.message);
            }

            return throwError(() => error);
        })
    );
};
